"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateRequestKeys = exports.PublicRequestKeys = void 0;
var PublicRequestKeys;
(function (PublicRequestKeys) {
    PublicRequestKeys["Alerts"] = "alerts";
    PublicRequestKeys["Authentication"] = "authentication";
    PublicRequestKeys["Blog"] = "blog";
    PublicRequestKeys["Blogs"] = "blogs";
    PublicRequestKeys["BlogPreview"] = "blogPreview";
    PublicRequestKeys["Competences"] = "competences";
    PublicRequestKeys["Branch"] = "branch";
    PublicRequestKeys["Branches"] = "branches";
    PublicRequestKeys["Homepage"] = "homepage";
    PublicRequestKeys["Homepages"] = "homepages";
    PublicRequestKeys["Job"] = "job";
    PublicRequestKeys["Jobs"] = "jobs";
    PublicRequestKeys["JobsLatest"] = "jobsLatest";
    PublicRequestKeys["Locals"] = "locals";
    PublicRequestKeys["Page"] = "page";
    PublicRequestKeys["Pages"] = "pages";
    PublicRequestKeys["Recruitment"] = "recruitment";
    PublicRequestKeys["Recruitments"] = "recruitments";
    PublicRequestKeys["Router"] = "router";
    PublicRequestKeys["Service"] = "service";
    PublicRequestKeys["Services"] = "services";
    PublicRequestKeys["ServicesFilter"] = "servicesFilter";
})(PublicRequestKeys = exports.PublicRequestKeys || (exports.PublicRequestKeys = {}));
var PrivateRequestKeys;
(function (PrivateRequestKeys) {
    PrivateRequestKeys["Role"] = "role";
    PrivateRequestKeys["Roles"] = "roles";
    PrivateRequestKeys["Permission"] = "permission";
    PrivateRequestKeys["Permissions"] = "permissions";
    PrivateRequestKeys["User"] = "user";
})(PrivateRequestKeys = exports.PrivateRequestKeys || (exports.PrivateRequestKeys = {}));
